exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modalComponent__QuickCreatorModal-module___xDvvI {\n    background-color: #0000001d;\n}\n\n.container__QuickCreatorModal-module___1gRDD {\n    margin-bottom: 8px;\n}", ""]);

// Exports
exports.locals = {
	"modalComponent": "modalComponent__QuickCreatorModal-module___xDvvI",
	"container": "container__QuickCreatorModal-module___1gRDD"
};